import React from "react"
import clsx from "clsx"

export interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string
  label: string
  id?: string
}

export const Checkbox: React.FC<CheckboxProps> = ({ className, label, id, ...props }) => {
  return (
    <div className={clsx("checkbox", className)}>
      <input type="checkbox" id={id ?? label} name={label} {...props} />
      <label htmlFor={id ?? label}>{label}</label>
    </div>
  )
}
